import { render, staticRenderFns } from "./OverallSetting.vue?vue&type=template&id=049656c2&scoped=true"
import script from "./OverallSetting.vue?vue&type=script&lang=js"
export * from "./OverallSetting.vue?vue&type=script&lang=js"
import style0 from "./OverallSetting.vue?vue&type=style&index=0&id=049656c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049656c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049656c2')) {
      api.createRecord('049656c2', component.options)
    } else {
      api.reload('049656c2', component.options)
    }
    module.hot.accept("./OverallSetting.vue?vue&type=template&id=049656c2&scoped=true", function () {
      api.rerender('049656c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/OverallSetting.vue"
export default component.exports